/**
 * Council logos from REACT_APP_HEADER_LOGO / BRAND_LOGO / CREST.
 * Env paths differ by file depth; load by filename from src/assets/images.
 */

const images = require.context('../assets/images', false, /\.(png|jpe?g|svg)$/i);

function fileName(envPath) {
    return String(envPath || '').split('/').pop();
}

function load(envPath) {
    const name = fileName(envPath);
    if (!name) return null;
    try {
        return images('./' + name);
    } catch (err) {
        return null;
    }
}

export const headerLogo = load(process.env.REACT_APP_HEADER_LOGO);
export const brandLogo = load(process.env.REACT_APP_BRAND_LOGO);
export const crestLogo = load(process.env.REACT_APP_CREST) || headerLogo;
